import { Title } from './styles'

const Header = () => (
  <Title>
    <h1>EBAC Jobs</h1>
  </Title>
)

export default Header
